import "./Tabla.css"

const Tabla = (props) => {
	let datos = []

	const construcción = [
		{
			descripcion: "Inspección en centro de ciudad, urbanizaciones y residenciales",
			tarifa: "3,000.00",
		},
		{ descripcion: "Inspección en barrios y zona rural", tarifa: "2,000.00" },
		{ descripcion: "Certificación UGAM", tarifa: "2,000.00" },
		{ descripcion: "Certificación de uso de suelo", tarifa: "30.00mt2" },
		{ descripcion: "Formulario R1 (recepción de proyectos)", tarifa: "500.00" },
		{ descripcion: "Revisión de planos", tarifa: "10.00mt2" },
		{ descripcion: "Tasación del valor de la obra", tarifa: "2.5x1,000.00" },
		{ descripcion: "Banner", tarifa: "750" },
		{ descripcion: "Materiales y/o escombros en vías y aceras", tarifa: "3,000.00" },
		{ descripcion: "Formulario de tramitación de planos", tarifa: "700.00" },
	]

	const Especiales = [
		{
			descripcion: "Formulario R1 (recepción de proyectos)",
			tarifa: "500.00",
		},
		{
			descripcion: "Inspección en centro de ciudad, urbanizaciones y residenciales",
			tarifa: "3,000.00",
		},
		{ descripcion: "Inspección en barrios y zona rural", tarifa: "3,000.00" },
		{ descripcion: "Certificación UGAM", tarifa: "2,500.00" },
		{ descripcion: "Certificación de uso de suelo", tarifa: "50.0/ml." },
		{ descripcion: "Formulario de tramitación de planos", tarifa: "700.00" },
	]

	const Cierredecalle = [
		{
			descripcion: "Calles en el centro de la ciudad",
			tarifa: "4,500.00",
		},
		{
			descripcion: "Calles secundarias en: residenciales, urbanizaciones y barrios",
			tarifa: "3,000.00",
		},
	]

	const RoturadeCalle = [
		{
			descripcion: "Cada tramo vías asfaltadas",
			tarifa: "2,000.00x ml.",
		},
		{
			descripcion: "Vías sin asfaltar cada tramo",
			tarifa: "1,000.00x ml.",
		},
		{
			descripcion: "Aceras",
			tarifa: "500.00 x ml.",
		},
	]

	const Demolicion = [
		{
			descripcion: "Inspección en centro de ciudad, urbanizaciones y residenciales",
			tarifa: "3,000.00",
		},
		{ descripcion: "Inspección en barrios y zona rural", tarifa: "2,000.00" },
		{ descripcion: "Certificación UGAM", tarifa: "2,000.00" },
		{ descripcion: "Certificación de uso de suelo de demolición ", tarifa: "25.00 x Mt2" },
		{ descripcion: "Impacto por acarreo de escombros", tarifa: "2,000.00" },
	]

	const RedesdeTelecomunicaciones = [
		{
			descripcion: "Certificación de uso de suelo para cabinas de distribución",
			tarifa: "100,000.00",
		},
		{ descripcion: "Inspección", tarifa: "5,000.00" },
		{ descripcion: "Certificación de la UGAM", tarifa: "5,000.00" },
		{
			descripcion: "Colocación de unidad de postes de tendido eléctrico.",
			tarifa: "3,000.00 c/u",
		},
		{ descripcion: "Colocación de unidad de anclas para postes ", tarifa: "2,000.00 c/u" },
		{ descripcion: "Instalación de cable (tendido normal) ", tarifa: "100.00 x ml" },
		{ descripcion: "Cambio de cable (tendido normal)", tarifa: "40.00 x ml" },
		{ descripcion: "Instalación de fibra óptica ", tarifa: "200.00 x ml" },
		{ descripcion: "Cambio de fibra óptica ", tarifa: "75.00 x ml" },
		{ descripcion: "Confección de Registros en aceras", tarifa: "15,000.00 c/u" },
	]

	const EstacionesdeCombustibles = [
		{
			descripcion: "Certificación de uso de suelo",
			tarifa: "300,000.00",
		},
		{ descripcion: "Formulario R1 (recepción de proyectos)", tarifa: "500" },
		{ descripcion: "Uso de suelo", tarifa: "70.00 x mt2" },
		{ descripcion: "Revisión de planos", tarifa: "10.00 x mt2" },
		{ descripcion: "Inspección", tarifa: "10,000.00" },
		{ descripcion: "Certificación de la UGAM", tarifa: "6,000.00" },
		{ descripcion: "Banner", tarifa: "750" },
		{ descripcion: "Parqueos para vehículos (cada uno)", tarifa: "1,500.00 c/u" },
		{ descripcion: "Parqueos para motores (cada uno)", tarifa: "500 c/u" },
		{ descripcion: "Roturas de aceras y contenes para acceso", tarifa: "3,500.00" },
		{
			descripcion: "Soterramiento de tanques de 1 a 4,000 gal.",
			tarifa: "50,000.00",
		},
		{
			descripcion: "Soterramiento de tanques de 4,001 a 12,000 gal.",
			tarifa: "75,000.00",
		},
		{
			descripcion: "Soterramiento de tanques de 12,001 a 20,000 gal.",
			tarifa: "100,000.00",
		},
		{
			descripcion: "Soterramiento de tanques de 20,001 a 30,000 gal.",
			tarifa: "125,000.00",
		},
		{
			descripcion: "Soterramiento de tanques de 30,000 en adelante",
			tarifa: "150,000.00",
		},
		{
			descripcion: "Renovación de tanques de 1 a 4,000 gal.",
			tarifa: "1,500.00",
		},
		{
			descripcion: "Renovación de tanques de 4,001 a 12,000 gal.",
			tarifa: "1,200.00",
		},
		{
			descripcion: "Renovación de tanques de 12,001 a 20,000 gal.",
			tarifa: "1,500.00",
		},
		{
			descripcion: "Renovación de tanques de 20,001 a 30,000 gal.",
			tarifa: "1,800.00",
		},
		{
			descripcion: "Renovación de tanques de 30,000 gal. en adelante",
			tarifa: "2,000.00",
		},
		{ descripcion: "Formulario de tramitación de planos", tarifa: "700" },
		{ descripcion: "Derecho a carga y descarga", tarifa: "150,000.00" },
	]

	const ReselladodePlanos = [
		{
			descripcion: "Resellado de planos",
			tarifa: "100",
		},
		{ descripcion: "Resellado de planos", tarifa: "150" },
	]

	const TorresTelecomunicacionesAntena = [
		{
			descripcion: "Certificación de uso de suelo para cabinas de distribución",
			tarifa: "100,000.00",
		},
		{ descripcion: "Inspección", tarifa: "5,000.00" },
		{ descripcion: "Certificación de la UGAM", tarifa: "5,000.00" },
		{
			descripcion: "Instalación de antenas con altura de 1-49 pies",
			tarifa: "15,000.00",
		},
		{
			descripcion: "Pago anual de torres (1-49 pies)",
			tarifa: "5,000.00",
		},
		{
			descripcion: "Instalación de antenas con altura de 50-99 pies",
			tarifa: "75,000.00",
		},
		{
			descripcion: "Pago anual de torres (50-99 pies)",
			tarifa: "10,000.00",
		},
		{
			descripcion: "Instalación de torres con altura de 100-149 pies",
			tarifa: "150,000.00",
		},
		{
			descripcion: "Pago anual de instalación de torres (100-149 pies)",
			tarifa: "15,000.00",
		},
		{
			descripcion: "Instalación de torres con altura de 150 pies en adelante",
			tarifa: "200,000.00",
		},
		{
			descripcion: "Pago anual de instalación de torres (150 pies en adelante)",
			tarifa: "25,000.00",
		},
	]

	const usoParques = [
		{
			descripcion: "Plaza Duarte",
			tarifa: "15,000.00",
		},
		{ descripcion: "Parque Blass Pezzoti", tarifa: "15,000.00" },
		{ descripcion: "Parque Elías Brache (Las Flores)", tarifa: "15,000.00" },
		{ descripcion: "Parque Padre Fantino", tarifa: "7,000.00" },
		{ descripcion: "Parque Juana Saltitopa (del Estudiante)", tarifa: "7,000.00" },
		{ descripcion: "Otros", tarifa: "5,000.00" },
	]

	const Cambiosdeusodesuelo = [
		{
			descripcion: "Inspección en centro de ciudad, urbanizaciones y residenciales",
			tarifa: "3,000.00",
		},
		{ descripcion: "Inspección en barrios y zona rural", tarifa: "2,000.00" },
		{ descripcion: "Certificación UGAM", tarifa: "2,000.00" },
		{ descripcion: "Certificación de uso de suelo", tarifa: "30.00 /mt2" },
	]

	switch (props.tipo) {
		case "construcción":
			datos = construcción
			break
		case "Especiales":
			datos = Especiales
			break
		case "Cierredecalle":
			datos = Cierredecalle
			break
		case "RoturadeCalle":
			datos = RoturadeCalle
			break
		case "Demolicion":
			datos = Demolicion
			break
		case "RedesdeTelecomunicaciones":
			datos = RedesdeTelecomunicaciones
			break
		case "EstacionesdeCombustibles":
			datos = EstacionesdeCombustibles
			break
		case "ReselladodePlanos":
			datos = ReselladodePlanos
			break
		case "TorresTelecomunicacionesAntena":
			datos = TorresTelecomunicacionesAntena
			break
		case "usoParques":
			datos = usoParques
			break
		case "Cambiosdeusodesuelo":
			datos = Cambiosdeusodesuelo
			break
		default:
			datos = construcción
	}

	return (
		<div className="Tabla">
			<table className="tablet">
				<thead>
					<tr>
						<th className="text-custom">Descripción</th>
						<th className="text-custom">Tarifa</th>
					</tr>
				</thead>
				<tbody>
					{datos.map((item) => (
						<tr key={item.descripcion}>
							<td>{item.descripcion}</td>
							<td>{item.tarifa}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}

export default Tabla
